module.exports = __webpack_public_path__ + "static/media/wom-mas-600-gigas.149819ad.svg";